import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Typography, Loader } from 'kangarootime-ui';
import moment from 'moment';
import WeekOverview from './WeekOverview';
import './MySchedule.css';
import RoomAssignments from './RoomAssignments';
import actions from './duck/actions';
import RaisedContainer from '../../../components/RaisedContainer';

class MySchedule extends Component {
  constructor (props) {
    super(props);

    this.state = {
      selectedDate: new Date(),
      date: new Date(),
      activeAssignmentIndex: 0,
      dailyAssignments: [] // keep track of today's shifts
    };
  }

  // start of week based on date in state
  get startOfWeek () {
    return moment(this.state.date).startOf('week');
  }

  // end of week based on date in state
  get endOfWeek () {
    return moment(this.state.date).endOf('week');
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (
      (prevProps.fetchingSchedule && !this.props.fetchingSchedule) &&
      (prevProps.shifts.length === 0 && this.props.shifts.length > 0)
    ) {
      this.setState({ dailyAssignments: this.assignmentsForDate(this.state.selectedDate) }, () => this.updateActiveAssignment());
    }
  }

  sameDate = (date1, date2) => moment(date1).isSame(moment(date2), 'date');

  /**
   * get dates of this week monday-friday
   */
  datesInWeek = () => {
    const start = this.startOfWeek;
    const end = this.endOfWeek;
    let currentDate = start;

    let dates = [];

    // need to use 'valueOf' on moment objects since semistandard says 'currentDate'/'end' is not modified in this loop
    while (currentDate.valueOf() <= end.valueOf()) {
      // don't add sunday and saturday
      if (currentDate.day() > 0 && currentDate.day() < 6) {
        const dateToAdd = currentDate.toDate();
        dates.push(dateToAdd);
      }

      currentDate.add('days', 1);
    }

    return dates;
  }

  groupObjectsByDate = arr => {
    const datesInWeek = this.datesInWeek();
    let obj = {};

    // create object where key is date in the week with the format 'YYYY-MM-DD'
    datesInWeek.forEach(date => {
      obj[moment(date).format('YYYY-MM-DD')] = [];
    });

    arr.forEach(item => {
      const formatted = moment(item.start).format('YYYY-MM-DD');

      if (obj[formatted]) {
        obj[formatted].push(item);
      }
    });

    return obj;
  }

  assignmentsForDate = date => {
    const { shifts } = this.props;
    let assignments = [];

    shifts.forEach(shift => {
      if (moment(shift.start).isSame(moment(date), 'date')) {
        assignments.push(shift);
      }
    });

    return assignments;
  }

  updateActiveAssignment = () => {
    const { dailyAssignments } = this.state;
    let activeIndex = dailyAssignments.length;

    for (let index = 0; index < dailyAssignments.length; index++) {
      const assignment = dailyAssignments[index];

      if (moment().isBetween(moment(assignment.start), moment(assignment.end))) {
        activeIndex = index;
        break;
      } else if (moment().isBefore(moment(assignment.start))) {
        activeIndex = 0;
        break;
      }
    }

    this.setState({ activeAssignmentIndex: activeIndex });
  }

  toggleWeek = numberOfWeeks => {
    const { date } = this.state;
    const clonedDate = moment(date).clone();

    this.setState({ date: clonedDate.add(numberOfWeeks, 'week') }, () => {
      this.props.fetchSchedule(this.startOfWeek.format('YYYY-MM-DD'), this.endOfWeek.format('YYYY-MM-DD'));
    });
  }

  render () {
    const { activeAssignmentIndex } = this.state;
    const { fetchingSchedule, shifts } = this.props;

    return (
      <Fragment>
        <RaisedContainer>
          <div style={{ margin: 8 }}>
            <Typography type='header'>Schedule</Typography>
            <Loader loading={fetchingSchedule && shifts.length === 0}>
              <WeekOverview
                dates={this.datesInWeek()}
                shifts={this.groupObjectsByDate(this.props.shifts)}
                openTimeOffRequestDialog={this.props.openTimeOffRequestDialog}
                requestingTimeOff={this.props.requestingTimeOff}
                timeOff={this.groupObjectsByDate(this.props.timeOff)}
                changeWeek={this.toggleWeek}
                showingCurrentWeek={moment(this.state.date).isSame(moment(), 'week')}
                selectedDate={this.state.selectedDate}
                onDateSelect={date => this.setState({ selectedDate: date })}
              />
            </Loader>
          </div>
        </RaisedContainer>
        <RaisedContainer>
          <div style={{ margin: 8 }}>
            <Typography type='header'>Assignment</Typography>
            <Loader loading={fetchingSchedule && shifts.length === 0}>
              <RoomAssignments
                assignments={this.assignmentsForDate(this.state.selectedDate)}
                activeAssignmentIndex={activeAssignmentIndex}
              />
            </Loader>
          </div>
        </RaisedContainer>
      </Fragment>
    );
  }
}

function mapStateToProps (state) {
  return {
    employeeId: state.identity.legacyUserId,
    fetchingSchedule: state.home.schedule.meta.fetchingSchedule,
    shifts: state.home.schedule.shifts,
    timeOff: state.home.schedule.timeOff
  };
}

function mapDispatchToProps (dispatch) {
  return {
    fetchSchedule: (start, end) => dispatch(actions.fetchScheduleRequest(start, end))
  };
}

MySchedule.propTypes = {
  openTimeOffRequestDialog: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(MySchedule);
